module.exports = __webpack_public_path__ + "img/BG_white.33da8b5d.gif";